import { FC } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';

import styles from './index.module.css';
import { IDropdownProps } from './types';

const Dropdown: FC<IDropdownProps> = ({ children, type, className, ...rest }) => {
  const dropdownClasses = classes(styles.dropdown, type && prop(`dropdown-${type}`, styles), className);

  return (
    <div className={dropdownClasses} {...rest}>
      {children}
    </div>
  );
};

export default Dropdown;
